import { FieldBase } from '@/components/form/fieldBase';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@e2n/ui';
import { CalendarSelectDrawerProps } from '@/domain/termine/features/UpdateTermin/shared';
import { useTranslation } from 'react-i18next';

export function CalendarSelectSheet({
  kalender,
  form,
}: CalendarSelectDrawerProps) {
  const { t } = useTranslation();

  return (
    <div>
      <form.AppField name="terminKalenderId">
        {(field) => {
          const calendarId = field.state.value ?? undefined;
          const selectedKalender = kalender.find(
            (k) => k.id === field.state.value,
          );
          const displayText = selectedKalender?.name;
          return (
            <FieldBase label={t('domain.termine.terminCalendar')}>
              <Select value={calendarId} onValueChange={field.handleChange}>
                <SelectTrigger
                  className="border-neutrals-300 w-full"
                  onBlur={field.handleBlur}>
                  {displayText}
                </SelectTrigger>
                <SelectContent className="border-none overflow-visible">
                  <SelectGroup>
                    {kalender.map((kalenderItem) => (
                      <SelectItem
                        className="p-2"
                        key={kalenderItem.id}
                        value={kalenderItem.id}>
                        <span className="text-sm font-medium">
                          {kalenderItem.name}
                        </span>
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </FieldBase>
          );
        }}
      </form.AppField>
    </div>
  );
}
